import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const SEAWEED_TYPES_API_URL =
  process.env.REACT_APP_SEAWEED_TYPES_API_URL || buildApiUrl('/seaweed-types');

export async function fetchSeaweedTypes() {
  const response = await requestSeaweedTypeApi(SEAWEED_TYPES_API_URL, {
    fallbackMessage: 'Unable to load seaweed types right now.',
  });

  return response.json();
}

export async function createSeaweedType(payload) {
  const response = await requestSeaweedTypeApi(SEAWEED_TYPES_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to save seaweed type right now.',
  });

  return response.json();
}

export async function updateSeaweedType(id, payload) {
  const response = await requestSeaweedTypeApi(`${SEAWEED_TYPES_API_URL}/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to update seaweed type right now.',
  });

  return response.json();
}

export async function deleteSeaweedType(id) {
  const response = await requestSeaweedTypeApi(`${SEAWEED_TYPES_API_URL}/${id}`, {
    method: 'DELETE',
    fallbackMessage: 'Unable to delete seaweed type right now.',
  });

  return response.json();
}

async function requestSeaweedTypeApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
